import { render, staticRenderFns } from "./CreateOwner.vue?vue&type=template&id=77a733ca"
import script from "./CreateOwner.vue?vue&type=script&lang=js"
export * from "./CreateOwner.vue?vue&type=script&lang=js"
import style0 from "./CreateOwner.vue?vue&type=style&index=0&id=77a733ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports